import { render } from "./AdminWorkspaces.vue?vue&type=template&id=a8770900"
import script from "./AdminWorkspaces.vue?vue&type=script&lang=js"
export * from "./AdminWorkspaces.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__